import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
`;
